/* Grail Peptides — Theme JS */

// ── Mobile nav ──
const mobileToggle = document.getElementById('mobile-toggle');
const mobileNav    = document.getElementById('mobile-nav');
const mobileClose  = document.getElementById('mobile-nav-close');
if (mobileToggle) {
  mobileToggle.addEventListener('click', () => mobileNav.classList.add('is-open'));
  mobileClose.addEventListener('click',  () => mobileNav.classList.remove('is-open'));
}

// ── Variant selection ──
document.querySelectorAll('.variant-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const group = btn.closest('.variant-selector');
    group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('is-active'));
    btn.classList.add('is-active');
    // Update hidden variant id input
    const input = document.getElementById('variant-id');
    if (input) input.value = btn.dataset.variantId;
    // Update price display
    const price = btn.dataset.price;
    const priceEl = document.querySelector('.product-info__price');
    if (priceEl && price) priceEl.textContent = price;
  });
});

// ── Quantity ──
document.querySelectorAll('.quantity-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const input = btn.closest('.quantity-wrap').querySelector('.quantity-input');
    let val = parseInt(input.value) || 1;
    if (btn.dataset.action === 'minus') val = Math.max(1, val - 1);
    if (btn.dataset.action === 'plus')  val = val + 1;
    input.value = val;
  });
});

// ── Add to cart ──
const addToCartForm = document.getElementById('add-to-cart-form');
if (addToCartForm) {
  addToCartForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn  = addToCartForm.querySelector('.btn--primary');
    const originalText = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;
    const formData = new FormData(addToCartForm);
    try {
      const res = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body:    JSON.stringify({
          id:       formData.get('id'),
          quantity: parseInt(formData.get('quantity')) || 1,
        }),
      });
      if (res.ok) {
        btn.textContent = 'Added ✓';
        btn.style.background = '#0E7490';
        updateCartCount();
        setTimeout(() => {
          btn.textContent = originalText;
          btn.style.background = '';
          btn.disabled = false;
        }, 2000);
      } else {
        throw new Error();
      }
    } catch {
      btn.textContent = 'Error — try again';
      btn.disabled = false;
    }
  });
}

// ── Update cart count in header ──
async function updateCartCount() {
  try {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
  } catch {}
}

// ── Cart line quantity update ──
document.querySelectorAll('.cart-line-qty').forEach(input => {
  input.addEventListener('change', async () => {
    const key = input.dataset.lineKey;
    const qty = parseInt(input.value);
    await fetch('/cart/change.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: key, quantity: qty }),
    });
    location.reload();
  });
});

// ── Gallery thumbnails ──
document.querySelectorAll('.product-gallery__thumb').forEach(thumb => {
  thumb.addEventListener('click', () => {
    const src = thumb.querySelector('img')?.src;
    const main = document.querySelector('.product-gallery__main img');
    if (main && src) main.src = src;
    document.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('is-active'));
    thumb.classList.add('is-active');
  });
});

// Init cart count on load
updateCartCount();
